const brickVideo = {
    init: function () {
        if ($('.video-wrapper').length > 0) {
            $('.video-thumbnail').on('click', function () {
                console.log('ici');
                
                $(this).fadeOut();
                let $videoWrapper = $(this).parents('.video-wrapper');

                if ($videoWrapper.find('iframe').length) {
                    // Lance la vidéo du player Youtube
                    $videoWrapper.find('iframe')[0].src += "&autoplay=1";
                } else if ($videoWrapper.find('video.wp-video-shortcode').length) {
                    // Lance la vidéo dans le player de Wordpress
                    $videoWrapper.find('.mejs-play button').trigger('click');
                }
            });
        }
    }
}

export { brickVideo };